import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { sessionsApi } from "src/api/taktileApi";
import { OrganizationSessions } from "src/clients/taktile-api";

type SessionParams = {
  skip: number;
  limit: number;
  includeExpired: boolean;
};

export const organizationSessionsKeys = {
  all: ["organizationSessions"] as const,
  list: (orgId: string, params: SessionParams) =>
    [...organizationSessionsKeys.all, "list", orgId, params] as const,
};

export const useOrganizationSessions = (
  organizationId: string,
  params: SessionParams,
) => {
  return useQuery<OrganizationSessions, AxiosError>({
    queryKey: organizationSessionsKeys.list(organizationId, params),
    queryFn: async () => {
      const response =
        await sessionsApi.getSessionsByOrganizationApiV1SessionsOrganizationIdGet(
          organizationId,
          params.skip,
          params.limit,
          params.includeExpired,
        );
      return response.data;
    },
    enabled: !!organizationId,
    placeholderData: keepPreviousData,
  });
};
